import React from 'react';
import {PlusOutlined} from '@ant-design/icons';
import {message, notification, Select, Spin, Tag, Tooltip} from 'antd';
import {connect} from 'react-redux'
import {addTagToTagList} from '../../redux_actions/dashboard.action';
import {loadTags} from '../../redux_actions/slides.action';
import querystring from "query-string";
import cookie from "react-cookies";
import {ArchiveConstants} from "../../utils/const";
import {get, post_response} from "../../helper/request";
import {performAbortControllerTagAndSlideSearch} from "../../utils/api";


class EditableTagGroup extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            tags: this.props.tag,
            inputVisible: false,
            inputValue: '',
            tag_suggestions: [],
            loadingSearchResults: false,
        }

        // This flag is used to avoid tagSubmit for out of focus press.
        // antd by default calls both onSelect and onBlur if user clicks outside input box and only onSelect if user press enter.
        // We only want to submit when user press enter.
        this.cancelAddTagCall = false;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.tag !== this.props.tag) {
            this.setState({
                tags: this.props.tag,
                inputVisible: false,
                inputValue: '',
                tag_suggestions: [],
            });
        }
    }

    updateSearchResults = (searchResults) => {
        this.setState({
            tag_suggestions: searchResults,
            loadingSearchResults: false,
        })
    }

    performSearch = (value) => {
        this.setState({
            loadingSearchResults: true,
        })
        performAbortControllerTagAndSlideSearch('#' + value,this.updateSearchResults)
    }

    handleClose = (removedTag) => {
        const tags = this.state.tags.filter(tag => tag !== removedTag);
        this.setState({ tags });
        this.removeSlideTag(removedTag);
    }
    openNotification = (value) => {
        notification.open({
          message: value,
          placement :'bottomRight'
        //   description: 'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
        });
        notification.config({
            placement: 'bottomRight',
          });
      };


    removeSlideTag= (removedTag) => {
        let url = `/api/remove_slide_tag/`;
        let val = {"title": removedTag.title, "created_by": removedTag.created_by, "slide_id" : this.props.morphle_id};
        post_response(url, querystring.stringify(val))
            .then(response => {
            if(response.status === 200 || response.status === 301 || response.status === 302) {
                this.props.dispatch(loadTags());
                this.openNotification('Slide Update Successful')
            }
            else if(response.status === 403 || response.status === 401 || response.status === 400) {
                this.openNotification('Slide Update Failed')
            }
        })
            .catch(err =>{
        });
    }

    showInput = () => {
        this.setState({ inputVisible: true }/*, () => this.input.focus()*/);
    }

    handleInputChange = (e) => {
        this.setState({ inputValue: e.target.value });
    }

    scheduleAddSlideTag = (values) => {
        setTimeout(() => { this.addSlideTag(values)}, 100);
    }

    addSlideTag= (values) => {

        if (this.cancelAddTagCall) {
            this.cancelAddTagCall = false;
            return;
        }

        if(values.length > 0) {
            let {tags} = this.state;
            let stripped = ('#' + values.toString().replace('#', '').replace(' ', '-')).toLowerCase();
            if (stripped && tags.indexOf({title: stripped, created_by: cookie.loadAll().username}) === -1) {
                tags = [...tags, {title: stripped, created_by: cookie.loadAll().username}];
            }

            let url = `/api/add_slide_tag/`;
            let val = {"title": stripped, "slide_ids" : JSON.stringify([this.props.morphle_id])};
            post_response(url, querystring.stringify(val))
                .then(response => {
                if(response.status === 200 || response.status === 301 || response.status === 302) {
                    if(!this.props.allTags.includes(stripped)) {
                        this.props.dispatch(addTagToTagList({title: stripped, created_by: cookie.loadAll().username}));
                    }
                    message.success('Slide Update Successful', 2.5);
                }
                else if(response.status === 403 || response.status === 401 || response.status === 400) {
                    message.error('Slide Update Failed', 2.5);
                }
            })
                .catch(err =>{
            });
            this.setState({
                tags,
                inputVisible: false,
                inputValue: '',
                tag_suggestions: []
            });
        } else {
            this.setState({
                inputVisible: false,
                inputValue: '',
                tag_suggestions: []
            });
        }
    }

    onBlurAction= (values) => {
        this.cancelAddTagCall = true;
        this.setState({
            inputVisible: false,
            inputValue: '',
            tag_suggestions: []
        });
    }

    //saveInputRef = input => this.input = input

    render() {
        const { tags, inputVisible } = this.state;

        let tagStyle = {
            marginTop: "5px",
            marginRight: "5px"
        }

        let selected = [];

        let numSuggested = this.state.tag_suggestions.length;

        let tagSuggestionsBox = numSuggested > 0 || this.state.loadingSearchResults ?
            <Select.OptGroup label={this.state.loadingSearchResults ?  <div><Spin size="small"/> <span style={{marginLeft: 5}}>{" Loading Results... "}</span></div> :
                <div><b>{numSuggested}</b> result{numSuggested > 1 ? 's' : ''} found </div>}>
                {this.state.tag_suggestions.map((item, index) => (
                    <Select.Option
                        key={index}
                        value={item.display_text}
                        label={item.display_text}
                        className='search-result-tag'
                        size='small'
                        type='tag'
                    >
                        {item.display_text} <span style={{float: "right", fontSize: 12}}></span>
                    </Select.Option>
                ))}
            </Select.OptGroup> : undefined;

        return (
            <div>
                {this.props.archival_status === ArchiveConstants.STATUS.LOCAL_ARCHIVAL ? <Tag>Archived</Tag> : null}
                {tags.map((tag, index) => {
                    const isLongTag = tag.title.length > 20;
                    const created_by_admin = tag.created_by === 'admin' ? true:false;
                    let color = created_by_admin ? 'green' : 'magenta';
                    let tagElem;
                    if((this.props.urlState || {}).presentCode !== undefined) {
                        tagElem = (
                            <Tag style={tagStyle} key={tag.title} color={color}>
                            {isLongTag ? `${tag.title.slice(0, 20)}...` : tag.title}
                            </Tag>
                        );
                    } else {
                        tagElem = (
                            <Tag style={tagStyle} key={tag.title} closable='true' color={color} onClose={() => this.handleClose(tag)}>
                            {isLongTag ? `${tag.title.slice(0, 20)}...` : tag.title}
                            </Tag>
                        );
                    }
                    if (isLongTag) {
                        const tooltipTitle = created_by_admin ? tag.title + ", visible only to admin" : tag.title;
                        return <Tooltip title={tooltipTitle} key={tag.title}>{tagElem}</Tooltip>
                    } else if (created_by_admin) {
                        return <Tooltip title={"visible only to admin"} key={tag.title}>{tagElem}</Tooltip>
                    } else {
                        return tagElem;
                    }
                })}
                {inputVisible && (
                    <div id={'viewer-tags-search-select'} className={'custom-dropdown-max-height'}>
                        <Select
                            showSearch
                            allowClear
                            autoFocus
                            className="search-tag"
                            showArrow={false}
                            filterOption={false}
                            notFoundContent={null}
                            mode="tags"
                            onSearch={this.performSearch}
                            onSelect={this.scheduleAddSlideTag}
                            onBlur={this.onBlurAction}
                            optionLabelProp="label"
                            value={selected}
                            getPopupContainer={() => document.getElementById('viewer-tags-search-select')}
                            style={{width:'100%', marginTop: 5}}
                        >
                            {tagSuggestionsBox}
                        </Select>
                    </div>
                )}
                {!inputVisible && this.props.edit && (
                <Tag
                    onClick={this.showInput}
                    style={{ background: '#fff', borderStyle: 'dashed', ...tagStyle }}
                >
                    <PlusOutlined /> New Tag
                </Tag>
                )}
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return{
        loginStatus :  state.loginAlerts.loginStatus,
        urlState: state.viewerUrlReducer,
        activeMapId: state.gammaStateReducer.activeMapId,
        allTags: state.dashboardReducer.allTags
    }
}

export default connect(mapStateToProps)(EditableTagGroup)
